"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LruCache = void 0;
/** Map-like cache capped at `maxSize` entries; evicts the least recently used */
class LruCache {
    maxSize;
    entries = new Map();
    constructor(maxSize) {
        this.maxSize = maxSize;
    }
    get size() {
        return this.entries.size;
    }
    get(key) {
        if (!this.entries.has(key)) {
            return undefined;
        }
        const value = this.entries.get(key);
        // Move it to the back, so the least recently used entry is first
        this.entries.delete(key);
        this.entries.set(key, value);
        return value;
    }
    set(key, value) {
        this.entries.delete(key);
        if (this.entries.size >= this.maxSize) {
            const oldest = this.entries.keys().next();
            if (!oldest.done) {
                this.entries.delete(oldest.value);
            }
        }
        this.entries.set(key, value);
    }
}
exports.LruCache = LruCache;
